import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    title: "电影",
    desc: "动作、科幻、爱情、悬疑……海量佳片按类型随心筛选",
    icon: "ri-movie-2-line",
    count: "15 部精选",
  },
  {
    to: "/category/tv",
    title: "电视剧",
    desc: "古装、都市、悬疑剧场……连载剧集一网打尽",
    icon: "ri-live-line",
    count: "13 部剧集",
  },
];

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {entries.map((entry, i) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative overflow-hidden rounded-lg border border-background-300 bg-background-100 hover:border-primary-400 transition-colors cursor-pointer p-6 md:p-8 flex items-center justify-between"
          >
            <div className={`absolute -right-6 -bottom-8 opacity-10 group-hover:opacity-20 transition-opacity ${
              i === 0 ? "text-primary-500" : "text-accent-500"
            }`}>
              <i className={`${entry.icon} text-[130px]`}></i>
            </div>
            <div className="relative z-10">
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-lg mb-4 ${
                  i === 0 ? "bg-primary-500" : "bg-accent-500"
                }`}
              >
                <i className={`${entry.icon} text-2xl text-background-50`}></i>
              </div>
              <h3 className="text-2xl font-bold text-foreground-950 font-heading mb-2">
                {entry.title}
              </h3>
              <p className="text-sm text-foreground-600 max-w-xs mb-4">{entry.desc}</p>
              <span
                className={`inline-flex items-center gap-1 text-sm font-medium ${
                  i === 0 ? "text-primary-400" : "text-accent-400"
                }`}
              >
                {entry.count}
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}